import { useContext } from 'react';
import TemplateTwilioContext from 'src/contexts/templateTwilio/templateTwilioContext';

const useTemplateTwilio = () => useContext(TemplateTwilioContext);

export default useTemplateTwilio;
